<template>
  <ReportTableWithHeader
    :loading="isLoading"
    :downloading="isDownloading"
    :rows="rows"
    :columns="columns"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :total-records="totalRecords"
    downloadable
    :type="reportType"
    :form="form"
    @onFilter="onFilter"
    @onPageChange="onPageChange"
    @onPerPageChange="onPerPageChange"
    @onDownload="onDownload"
  />
</template>

<script>
import reportTableMixin from '@/mixins/reportTableMixin';

export default {
  mixins: [reportTableMixin],

  data() {
    return {
      columns: [
        { field: 'account' },
        { field: 'userName' },
        { field: 'userRegister' },
        { field: 'borrower' },
        { field: 'paidDate' },
        { field: 'increaseRateAmount' },
        { field: 'rateAmount' },
        { field: 'amount' },
        { field: 'paidAmount' },
        { field: 'currency' },
        { field: 'productName' },
        { field: 'productName' },
        { field: 'productName' },
      ],
      reportType: 'loanRepayment',
    };
  },

  methods: {
    updateFilters(data) {
      data.filters[`filter[status]`] = 'PAID';
      data.filters[`filter[reportType]`] = this.reportType;
    },
  },
};
</script>
